<template>
  <div
    class="spinner"
    :style="{ height: height }"
  >
    <div
      class="spinner-wheel"
      :style="{
        borderWidth: borderWidth,
        borderTopColor: borderColor,
        borderBottomColor: borderColor,
        height: height,
        width: width,
      }"
    />
  </div>
</template>

<script>
export default {
  name: "Spinner",

  props: {
    color: {
      type: String,
      default: "#002342",
    },

    size: {
      type: String,
      default: "base",
    },
  },

  computed: {
    borderColor() {
      return this.color;
    },
    borderWidth() {
      let val;
      if (this.size == "sm") val = "2px";
      if (this.size == "base") val = "3px";
      if (this.size == "lg") val = "5px";
      if (this.size == "xl") val = "7px";
      return val;
    },
    height() {
      let val;
      if (this.size == "sm") val = "35px";
      if (this.size == "base") val = "50px";
      if (this.size == "lg") val = "100px";
      if (this.size == "xl") val = "125px";
      return val;
    },
    width() {
      let val;
      if (this.size == "sm") val = "35px";
      if (this.size == "base") val = "50px";
      if (this.size == "lg") val = "100px";
      if (this.size == "xl") val = "125px";
      return val;
    },
  },
};
</script>
